import { version } from '../../../../package.json';

/**
 * Versão da aplicação web, lida do package.json (fonte única — a versão é escrita à mão
 * no commit da entrega, então não há como a versão exibida divergir da publicada).
 */
export const VERSAO_APP: string = version;
